import { render, staticRenderFns } from "./TagClassifyDialog.vue?vue&type=template&id=d2d95312&scoped=true"
import script from "./TagClassifyDialog.vue?vue&type=script&lang=js"
export * from "./TagClassifyDialog.vue?vue&type=script&lang=js"
import style0 from "./TagClassifyDialog.vue?vue&type=style&index=0&id=d2d95312&prod&lang=css"
import style1 from "./TagClassifyDialog.vue?vue&type=style&index=1&id=d2d95312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d95312",
  null
  
)

export default component.exports